<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <gift-list-table></gift-list-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import giftListTable from './GiftListTable.vue'

  export default {
    name: 'gift-list',
    components: {giftListTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/giftlist/GiftList.vue